import { Id } from "@dgs/core";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { regionsService } from "./regionsService";

export const useRegionQuery = (regionId: Id | null, registrationToken: string | null) => {
	const { data } = useQuery({
		queryKey: [...regionsService.baseKey, regionId, registrationToken],
		queryFn: () => regionsService.getRegion(regionId, registrationToken).then((res) => res.data.data),
		placeholderData: keepPreviousData,
	});

	return { region: data };
};

export const useRegionOptionsQuery = () => {
	const { data, isLoading } = useQuery({
		queryKey: regionsService.optionsKey,
		queryFn: () => regionsService.getRegionsOptions().then((res) => res.data.data),
	});

	return { data, isLoading };
};
